module.exports = __webpack_public_path__ + "static/4-fd47334c1643c1401b338cdcfbe4c5df.gif";